export default {"src":"/_next/static/media/locationMap.35f77ead.svg","height":21,"width":15,"blurWidth":0,"blurHeight":0};